export default __webpack_public_path__ + "assets/images/globalThreshMask-afb9b19785ad121cb620ac8359e8feac.jpg";